import React from "react";
import ReactTable from "react-table";
import { Button } from "react-bootstrap";
import autoBind from 'react-autobind';
//
import CustomComponent from "./../components/CustomComponent";
import CustomNavigationController from '../components/CustomNavigationController';
import AdminRejectionModal from "./subviews/AdminRejectionModal";
import CommonLoadingView from "./subviews/CommonLoadingView";
import Utils from "./../components/Utils";
import CommonLogTable from "./subviews/CommonLogTable";

//
//import "./../stylesheets/admSubmissions.css";
//
export default class AdminReportManagement extends CustomComponent {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {data: [], firstLoad: true, isLoading: false };
  }
  loadResponse(response) {
    //valid data state
    if (response['data'] != null) { this.state.data = response['data']; }
    else { //non-valid data state
      if (response["errorData"]) this.props.alertController.showErrorAlert("Error!","",response);
      this.state.data = [];
    }
    this.state.firstLoad =  false;
    this.stopLoading(false);
    this.setState(this.state);
  }
  async componentDidMount() {
    if (this.state.firstLoad) this.fetchData();
  }
  //API
  fetchData() {
    this.startLoading()
    this.props.app.sharedAPIWrapper().fetchMonthlyReportsForApproval(response => {
      if (!this._isMounted) return;
      this.loadResponse(response);
    });
  }
  //Actions
  handleRowClick(event, row) {
    this.props.navigationController.pushView(
      <CommonLogTable reportMR={row.original} app={this.props.app}
                      alertController={this.props.alertController}
                      editable/>
    );
  }
  handleRejectSubmission(data, e) {
    e.stopPropagation(); //prevents click on the table cell
    this.rejectionModal.handleShow(data);
  }
  handleApproveSubmission(data, e) {
    e.stopPropagation(); //prevents click on the table cell
    this.handleSubmission(data, true);
  }
  handleSubmission(e,approved) {
    //confirmation ask
    if (!this.props.alertController.showQuestionAlert("Attention!","Do you really want to " + (approved ? "approve" : "reject") + " this submission? ")) return;
    //Action
    this.startLoading();
    this.props.app.sharedAPIWrapper().submitMonthlyReportDecision(e, approved ,response => {
      if (!this._isMounted) return;
      if (!response["error"]) {
        this.props.alertController.showSuccessAlert("Success","Monthly report " + (approved ? "approved" : "rejected") + " with success!");
        this.fetchData();
      } else {
        this.props.alertController.showErrorAlert("Error","Error while " + (approved ? "approving" : "rejecting") +  " monthly report.",response);
        this.stopLoading();
      }
    });
  }
  //UI
  render() {
    const data = (this.state.data == null ? [] : this.state.data);
    const props = {
      showPagination: false,
      minRows: 6,
      defaultPageSize: 1000,
      noDataText: "No data!",
      loadingText: "Loading...",
      keyField :'pk',
      defaultSorted: [{ id: "sky", desc: false}, { id: "skm", desc: false}],
      loading:this.state.isLoading,
      getTrProps: (s, r) => {
        return { onClick: (e) => { this.handleRowClick(e, r) } };
      }
    };
    const columns = [
    {
      Header: 'Submission Year',
      accessor: d => (d['sk'] ? d['sk'].slice(0,4) : ""),
      id: "sky",
      width: 200
    },{
      Header: 'Submission Month',
      id: 'skm',
      width: 200,
      accessor: d => d.sk ? d.sk.slice(4,6) : "",
      Cell: props => { return Utils.getMonthName(props.value) }
    },{
      Header: 'Advisor Name',
      id: 'pku',
      accessor: d => (d['pk'] ? this.props.app.sharedCache().findDisplayNameByID(d["pk"].replace("MS::","")) : "")
    },{
      Header: 'Total Costs($)',
      width: 200,
      accessor: d => Utils.toCurrencyFormat(d['totalclaimaftertax']),
      id:"totalclaimaftertax"
    },{
      Header: '',
      id: 'pk',
      sortable: false,
      width: 250,
      Cell: props => {
        return (<span className='tableButtonContainer'>
                  <Button className="tableDeleteButton" variant="danger" onClick={this.handleRejectSubmission.bind(this,props.original)}> Reject </Button>
                  <Button className="tableEditButton" variant="success" onClick={this.handleApproveSubmission.bind(this,props.original)}> Approve </Button>
                </span>);
      }
    }];
    //render
    return (
    <div className="AppPageContainer">
      <CommonLoadingView isLoading={this.state.isLoading}/>
      <AdminRejectionModal {... Utils.propagateRef(this, "rejectionModal")} app={this.props.app} handleSubmission={this.handleSubmission}/>
      <ReactTable data={data} className="v-100 -highlight" columns={columns} {... props}/>
    </div>);
  }
}
//Navigation container implementation
export class AdminReportManagementNavigationController extends CustomNavigationController {
  constructor(props) {
    super(props);
    this.containerClass = AdminReportManagement;
  }
}
